import { render, staticRenderFns } from "./ProviderPort.vue?vue&type=template&id=36346eab&scoped=true&"
import script from "./ProviderPort.vue?vue&type=script&lang=js&"
export * from "./ProviderPort.vue?vue&type=script&lang=js&"
import style0 from "./ProviderPort.vue?vue&type=style&index=0&id=36346eab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36346eab",
  null
  
)

export default component.exports